
import React, { useState, useEffect } from 'react';
import Nav from "./Nav";
import Axios from "axios";
import Loader from "../user/Loader";
import { BiAddToQueue } from "react-icons/bi";
import { FaUserCheck } from "react-icons/fa";
import { RiLockPasswordLine } from "react-icons/ri";

const StudentData = (props) => {
    const [open, setOpen] = useState(false);
    const [studentData, setStudentData] = useState([]);
    const [token, setToken] = useState(props.match.params.id);
    const [services, setServices] = useState([]);
    const [emptyDataText, setEmptyDataText] = useState("");
    const [locations, setLocations] = useState([]);

    const fetchData = () => {
        const listOfServices = Axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_SERVICE_LIST_URL);
        const listOfLocations = Axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_CAMPUS_LIST_URL);


        Axios.all([listOfServices, listOfLocations])
            .then(Axios.spread((...data) => {
                const serviceData = data[0];
                const locationData = data[1];
                setServices(serviceData.data);
                setLocations(locationData.data);
            }))
    }

    const getService = (serviceId) => {
        let serviceTitle = "";

        for (let service of services) {
            if (service.serviceId === serviceId) {
                serviceTitle = service.service_description;
                break;
            }
        }
        return serviceTitle;
    }

    const getLocation = (locationId) => {
        let locationTitle = "";

        for (let location of locations) {
            if (location.locationId === locationId) {
                locationTitle = location.campusLocation;
                break;
            }
        }
        return locationTitle;
    }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };


    useEffect(() => {
        fetchData();
        handleToggle();
        Axios.get(`${process.env.REACT_APP_BASEURL + process.env.REACT_APP_STUDENT_DATA_URL + token}`)
            .then(res => {
                handleClose();
                if (res.data.data != null) {
                    setStudentData([res.data.data]);
                    setEmptyDataText("");
                }
                else {
                    setEmptyDataText("No data");
                }


            })
            .catch(err => {
                handleClose();
                setEmptyDataText("No data");
            })
    }, []);

    return (

        <div className="service-staff-body">
            <Nav 
                headerText="STAFF" 
                nav1="Service Queue" 
                nav2="Code Verification" 
                path2="/verify" 
                path1="/serviceQueue" 
                icon2={<BiAddToQueue />} 
                icon1={<FaUserCheck />} 
            />
            <div className="body">
                <div >
                    <div className="student-data-container">
                        <div className="header-container">
                            <h2>BIODATA</h2>
                        </div>
                        <hr />
                        <div className="biodata-container">


                            {studentData[0] != null ?
                                <table className="data-inner-container">
                                    {studentData.map((data) => {
                                        let timeFrom = data.slot.split(/[a-zA-Z]+/g);
                                        let currentDate = timeFrom[0].split("-");
                                        let formatedDate = currentDate[2] + "-" + currentDate[1] + "-" + currentDate[0];
                                        let time = timeFrom[1];
                                        return <tbody key={data.studentId}>
                                            <tr>
                                                <th className="table-head">Matric Number:</th>
                                                <td className="table-data">{data.matricNo}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Surname:</th>
                                                <td className="table-data">{data.surname}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Phone Number:</th>
                                                <td className="table-data">{data.phoneNumber}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Email:</th>
                                                <td className="table-data">{data.email}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Department:</th>
                                                <td className="table-data">{data.department}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Service:</th>
                                                <td className="table-data">{getService(data.serviceId)}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Campus Location:</th>
                                                <td className="table-data">{getLocation(data.locationId)}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Time:</th>
                                                <td className="table-data">{time}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-head">Date:</th>
                                                <td className="table-data">{formatedDate}</td>
                                            </tr>
                                        </tbody>
                                    })}

                                </table> : <h1>{emptyDataText}</h1>}

                        </div>
                    </div>
                </div>
            </div>
            <Loader state={open} />
        </div>


    )
}
export default StudentData;